export { Price } from '@jetshop/ui/Price';
